import React, { Component } from "react";
import { Spin } from "antd";
import { RESTExecutor, withDomains } from "../../../lib/domain";
import ErrorWrapper from "../../../lib/error_wrapper";
import TableAdd from "./table_add";

class TableEdit extends Component {
  constructor(props) {
    super(props);

    this.table_id = props.match.params.table_id;

    this.state = {
      edit_data: {},
      edit_id: null,
      loading: true,
    };

    this.table_detail = RESTExecutor.detail()
      .config({
        label: "tables_detail",
      })
      .forId(this.table_id)
      .callbacks(
        (success) => {
          this.setState({
            loading: false,
            edit_data: success.result,
            edit_id: success.result.id,
          });
        },
        (error) => {
          this.setState({ loading: false });
        }
      )
      .connect(props.domains.settings);

    this.table_detail.execute();
  }

  render() {
    const { edit_data, edit_id, loading } = this.state;
    let table_detail_resp = this.table_detail.response();

    if (loading) {
      return (
        <center>
          <Spin />
        </center>
      );
    }
    return (
      <ErrorWrapper
        error={table_detail_resp}
        onReload={() => {
          this.setState({ loading: true, edit_id: null });
          this.datatype_detail.forId(this.table_id).execute();
        }}
      >
        <TableAdd
          edit_data={edit_data}
          edit_id={edit_id}
          key={`${edit_id}--`}
          history={this.props.history}
        />
      </ErrorWrapper>
    );
  }

  componentWillReceiveProps(nextProps) {
    var oldtable_id = this.props.match.params.table_id;
    var newtable_id = nextProps.match.params.table_id;

    if (oldtable_id !== newtable_id) {
      this.table_id = newtable_id;

      this.setState(
        {
          loading: true,
        },
        () => {
          this.table_detail.forId(this.table_id).execute();
        }
      );
    }
  }
}

export default withDomains(TableEdit, "settings");
